import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { useNotification } from "../../../context/NotificationContext";

const SubscriberModelPopup = ({ onSave, subscriberData, isEditing }) => {
  const { register, handleSubmit, formState: { errors }, reset, setValue } = useForm();
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");
  const { notify } = useNotification();

  useEffect(() => {
    if (isEditing && subscriberData) {
      setValue("name", subscriberData.name);
      setValue("email", subscriberData.email);
      setValue("phone", subscriberData.phone);
      setValue("industry", subscriberData.industry);
      setValue("country", subscriberData.country);
      setValue("status", subscriberData.status.toString()); // Convert to string for select
    } else {
      reset();
    }
  }, [isEditing, subscriberData, reset, setValue]);

  const onSubmit = async (data) => {
    data.status = parseInt(data.status, 10); // Convert status to number
    try {
      const url = isEditing ? `${apiUrl}/campaign/contacts/update/${subscriberData.id}` : `${apiUrl}/campaign/contacts/contact`;
      const method = isEditing ? 'put' : 'post';
      const response = await axios[method](url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      notify("success", `Subscriber ${isEditing ? 'updated' : 'added'} successfully`);
      const updatedSubscriber = {
        id: isEditing ? subscriberData.id : response.data.id,
        ...data,
        Remarks: isEditing ? subscriberData.Remarks : [],
      };
      onSave(updatedSubscriber);
      reset();
      document.querySelector('[data-bs-dismiss="modal"]').click(); // Close the modal
    } catch (error) {
      notify("error", `Failed to ${isEditing ? 'update' : 'add'} subscriber. Please try again later.`);
    }
  };

  return (
    <div id="add_subscriber" className="modal custom-modal fade" role="dialog">
      <div className="modal-dialog modal-lg" style={{ margin: 0, position: "fixed", right: 0, height: "100vh", width: "40%" }}>
        <div className="modal-content h-100 d-flex flex-column">
          <form onSubmit={handleSubmit(onSubmit)} className="d-flex flex-column h-100">
            <div className="modal-header">
              <h5 className="modal-title">{isEditing ? "Edit Subscriber" : "Add Subscriber"}</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body flex-grow-1 overflow-auto" style={{ maxHeight: "calc(100vh - 120px)" }}>
              <div className="scrollable-container">
                <div className="form-group row mb-3">
                  <label className="col-md-4 col-form-label">
                    Name <span className="text-danger">*</span>
                  </label>
                  <div className="col-md-8">
                    <input
                      className="form-control"
                      type="text"
                      {...register("name", { required: "Name is required" })}
                    />
                    {errors.name && <span className="text-danger">{errors.name.message}</span>}
                  </div>
                </div>
                <div className="form-group row mb-3">
                  <label className="col-md-4 col-form-label">
                    Email
                  </label>
                  <div className="col-md-8">
                    <input
                      className="form-control"
                      type="email"
                      {...register("email")}
                    />
                  </div>
                </div>
                <div className="form-group row mb-3">
                  <label className="col-md-4 col-form-label">
                    Phone
                  </label>
                  <div className="col-md-8">
                    <input
                      className="form-control"
                      type="text"
                      {...register("phone")}
                    />
                  </div>
                </div>
                <div className="form-group row mb-3">
                  <label className="col-md-4 col-form-label">
                    Industry
                  </label>
                  <div className="col-md-8">
                    <input
                      className="form-control"
                      type="text"
                      {...register("industry")}
                    />
                  </div>
                </div>
                <div className="form-group row mb-3">
                  <label className="col-md-4 col-form-label">
                    Country
                  </label>
                  <div className="col-md-8">
                    <input
                      className="form-control"
                      type="text"
                      {...register("country")}
                    />
                  </div>
                </div>
                <div className="form-group row mb-3">
                  <label className="col-md-4 col-form-label">
                    Status <span className="text-danger">*</span>
                  </label>
                  <div className="col-md-8">
                    <select
                      className="form-control"
                      {...register("status", { required: "Status is required" })}
                    >
                      <option value="1">Active</option>
                      <option value="0">Inactive</option>
                    </select>
                    {errors.status && <span className="text-danger">{errors.status.message}</span>}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                Close
              </button>
              <button className="btn btn-primary submit-btn" type="submit">
                {isEditing ? "Save Changes" : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SubscriberModelPopup;